function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0",
  transform: "scale(0.0208333)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 48,
  height: 48,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAB1UlEQVRoge2Xv0oDQRDGf4ooaqKQxj8E0YCW4iMIFsY24GvoO1iIlckjiK34LlrZiIgQNVYxRTA2scihl8nduTe7yRHdD5Ywtzsz35eZzVzAY3zRArqO1ruWxKSaPrxY+DqLZSPg2cLXWSxfAUfwFdDAV8BFrLGvgA1yuBtkuRFz/4aLaayewmDXQuDmHljFsBXgonetYvz5ChSBK356fU/su6iAFFAOcrWAa2AzyXkqYa8I3AKF0LOlX5JrIGMsB595oALsAttAPco5qQJV+snDoIBh3AGZowCcxzknCdiPeDaKCsgccVx+hfy9jsJWxLm0K67HTfJbC3AxjeOmsLWAD8NEw0Be5G7HHUy6Ay1hr9jzMsaqsJtxB5MEPAq7pGWjwIawn+IOJgm4EfaBmk56lIUtuRjhkP4+rANz4kwJqAF39PrU9OK2A58ag9/2bJArfL6iETDP4OtyNbR/DHRSkI5bHeAoFPdM7DcDUSqcOiBou0605AEWgYcMyd8DCzYCAHaARgbkX+m9xDnBOnAJvI2AeAO4ANZMiE0oxHSAaYWfCT6BmTQOGgFdhU8apOJk+5cyc4y9AE0LmUK22lByjX0FvICs4QVkDT/IsoYX4PHf8QVNaE6z8KJIvAAAAABJRU5ErkJggg=="
}));

var SvgChair = function SvgChair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chair.edf34c20.svg";
export { ForwardRef as ReactComponent };